// extracted by mini-css-extract-plugin
export default {"screentitle":"ScreenTitle_screentitle__Wx1ob"};